import { render, staticRenderFns } from "./WorkflowInstanceDetail.vue?vue&type=template&id=f783dd32&scoped=true"
import script from "./WorkflowInstanceDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowInstanceDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkflowInstanceDetail.vue?vue&type=style&index=0&id=f783dd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f783dd32",
  null
  
)

export default component.exports